export const getNotificationKeys = {
    all: [{ scope: 'notifications' }] as const,
    lists: () => [{ ...getNotificationKeys.all[0], entity: 'list' }] as const,
    list: (search: string, page: number, type?: string | undefined, isOpenModal?: boolean) =>
        [{ ...getNotificationKeys.lists()[0], search, page, type, isOpenModal }] as const,
    counts: () => [{ ...getNotificationKeys.all[0], entitiy: 'count' }] as const,
    notificationTypes: () => [{ ...getNotificationKeys.all[0], entitiy: 'notificationtypes' }] as const
};
